export default __webpack_public_path__ + "static/media/keto_digestion@2x.78f44932.jpg";